import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.mjs";
import { __require as o } from "../node_modules/i18n-iso-countries/index.mjs";
var t = o();
const i = /* @__PURE__ */ r(t);
export {
  i as default
};
